"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flowStatuses = void 0;
var flowStatuses;
(function (flowStatuses) {
    flowStatuses["PENDING_ONBOARDING"] = "pendingOnboarding";
    flowStatuses["PENDING_CONSENT"] = "pendingConsent";
    flowStatuses["CONSENTED"] = "consented";
    flowStatuses["PENDING_TEST"] = "pendingTest";
    flowStatuses["TEST_FAILED"] = "testFailed";
    flowStatuses["OPTED_OUT"] = "optedOut";
    flowStatuses["TEST_COMPLETED"] = "testCompleted";
    flowStatuses["COOLING_OFF"] = "coolingOff";
    flowStatuses["PENDING_FOLLOWUP_TEST"] = "pendingFollowUpTest";
    flowStatuses["PENDING_PRE_APPROVAL"] = "pendingPreApproval";
    flowStatuses["DECLINED"] = "declined";
    flowStatuses["INELIGIBLE"] = "ineligible";
    flowStatuses["UNAUTHORIZED"] = "unauthorized";
    flowStatuses["PENDING_SERVICE_QUALIFICATION"] = "pendingServiceQualification";
})(flowStatuses || (exports.flowStatuses = flowStatuses = {}));
